export default __webpack_public_path__ + "static/media/nice.f303f503.svg";